import { Expose } from "class-transformer";

export class CreateBusinessUnitDto {
  @Expose()
  name: string;
}
